import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=3ee50a42&"
import script from "./Overlay.vue?vue&type=script&lang=js&"
export * from "./Overlay.vue?vue&type=script&lang=js&"
import style0 from "./Overlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee50a42')) {
      api.createRecord('3ee50a42', component.options)
    } else {
      api.reload('3ee50a42', component.options)
    }
    module.hot.accept("./Overlay.vue?vue&type=template&id=3ee50a42&", function () {
      api.rerender('3ee50a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/overlays/Overlay.vue"
export default component.exports